import React, { useState } from 'react';
import PdfViewer from "./PdfViewer";

const FragmentsViewer = ({ fragmentData }) => {
  const [pageView, setPageView] = useState(0);
  const FragementItem = (props) => {
    const fragment = props.fragementItem
    return !fragment?.fields.SubType && (
      <div className="content-fragment" key={fragment?.id}>
        <div
          className="content-styling"
          dangerouslySetInnerHTML={{
            __html: fragment?.fields.Content,
          }}
        />
      </div>
    ) || (<PdfViewer fragment={fragment} fragmentZoom={props.fragmentZoom} />)
  }
  const NextFragment = () => {
    if (pageView < (fragmentData.length - 1)) {
      setPageView(pageView + 1)
    }
  }
  const PreviousFragment = () => {
    if (pageView !== 0) {
      setPageView(pageView - 1)
    }
  }
  return (
    <>
      <FragementItem fragementItem={fragmentData[pageView]} fragmentZoom={1.05} />
      {
        (fragmentData.length > 1) && (
          <div className="fixed bottom-2 w-96" style={{ left: `calc(50vw - 10.5rem)`, bottom: "10px" }}>
            {(pageView !== 0) && (<button className="button float-left bg-gray-300 hover:bg-gray-400 text-gray-800 font-normal text-base py-1 px-3 rounded-l focus:outline-none w-32 " onClick={() => PreviousFragment()}>
              Previous
            </button>)
            }
            <span className="inline-block mx-7 mt-1 mr-4 w-16 text-center" style={{
              marginLeft: ((pageView === 0) ? `9rem` : `1rem`)
            }}>{pageView + 1} / {fragmentData.length}</span>
            {(pageView < (fragmentData.length - 1)) && (<button className="button  float-right bg-gray-300 hover:bg-gray-400 text-gray-800 font-normal text-base py-1 px-3 rounded-r focus:outline-none w-32 " onClick={() => NextFragment()}>
              Next
            </button>)}
          </div>
        )
      }
    </>
  )
}

export default FragmentsViewer;
